import { parseNumericString } from './methods';

export function uuid(): string {
  // Adapted from https://stackoverflow.com/a/2117523
  return (String(1e7) + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      parseInt(c) ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (parseInt(c) / 4)))
    ).toString(16)
  );
}

// configured to work with antd Form.Item
export const validateSAGID = (rules, unionId: string): Promise<any> => {
  if (!unionId) return Promise.reject();
  if (isNaN(parseNumericString(unionId)))
    return Promise.reject('SAG-AFTRA ID must be entirely numerical');
  if (unionId.length < 8)
    return Promise.reject('SAG-AFTRA ID should be 8-10 digits!');
  if (unionId.length > 10)
    return Promise.reject('SAG-AFTRA ID should not exceed 10 digits!');
  return Promise.resolve(); // valid
};
